export { default } from './logoRegular';
